import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadColorPacks, setSelectedColor } from '../../../../../../store/actions/admin/create-event';
import { addChecklistItem } from '../../../../../../store/actions/authentication';
import { ChecklistTitles } from '../../../../../../store/reducers/admin/assistant';
import { EventsState } from '../../../../../../store/types';
import { Color } from '../../../../../../types/working-model';
import ColorPack from './color';

export default function Colors(): JSX.Element {
	const {
		CreateEventReducer: {
			colorPacks,
			workingEvent
		},
		AuthReducer: {
			token,
			user
		}
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadColorPacks(token!, user!.active_channel));
	}, [dispatch, token, user]);

	function selectColor(color: Color) {
		return () => {
			// ASSISTANT CHECKLIST ITEM: complete users checklist item for selecting a new color palette
			if (
				user &&
				!user.onboarded.includes(ChecklistTitles.editColors)
			) dispatch(addChecklistItem(token!, user.id, user.onboarded, ChecklistTitles.editColors));

			dispatch(setSelectedColor(JSON.parse(JSON.stringify(color))));
		};
	}

	return (
		<div className="colors-container">
			{!!workingEvent && colorPacks?.map((color: Color) => {
				return (
					<ColorPack
						selected={workingEvent?.settings.design.colors.color_pack === color.color_pack}
						onClick={selectColor(color)}
						color={color}
						key={color.color_pack}
					/>);
			})}
		</div>
	);
}